export default __webpack_public_path__ + "static/media/IMM_dark_logo_centered.b04153eb.png";